import { EMaterialCategory, ENumberOfPropellers, EProducer, EPropellerDirectionWithRespectToTheQuay, ETypeOfPropeller } from '../../../shared/enum';
import { IMaterial } from '../../../shared/iProject';
import doubleBowThrusterTransversal from './Double_Bow_Thruster_Transversal.png';
import mainPropellerTransverse from './Main_Propeller_Transverse.png';
import mainPropellerParallel from './Main_Propoller_Parallel.png';
import { ISrcImage } from './NewEngine';
import singleBowThrusterTransversal from './Single_Bow_Thruster_Transversal.png';
import MaterialMaccaferriPattern from './material_macca_pattern.svg';
import MaterialRipRapPattern from './material_riprap_pattern.svg';

const changeTextureColor = (texture: string, color: string): string => {
    let decodedImage = atob(texture.substring(26));
    decodedImage = decodedImage.replaceAll('currentColor', color);
    return 'data:image/svg+xml;base64,' + btoa(decodedImage);
};

export const getTextureByMaterial = (material: IMaterial): string => {
    if (material.producer == EProducer.Maccaferri) {
        return changeTextureColor(MaterialMaccaferriPattern, material.color);
    } else if (material.category == EMaterialCategory.RipRap) {
        return changeTextureColor(MaterialRipRapPattern, material.color);
    } else {
        return '';
    }
};

export const loadImages = (sources: ISrcImage, callback: (images: any) => void) => {
    var images = {};
    var loadedImages = 0;
    var numImages = 0;
    for (var src in sources) {
        numImages++;
    }
    for (var src in sources) {
        images[src] = new Image();
        images[src].onload = function () {
            if (++loadedImages >= numImages) {
                callback(images);
            }
        };
        images[src].src = sources[src as TSrcImage];
    }
};

export const loadGif = (src: any, layer: any) => {
    var canvas = document.createElement('canvas');

    window.gifler(src).get(a => {
        a.animateInCanvas(canvas);
        a.onDrawFrame = (ctx, frame) => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = frame.width;
            canvas.height = frame.height;
            ctx.drawImage(frame.buffer, 0, 0);
            layer.draw();
        };
    });

    return canvas;
};

export const getImageFromScenario = (typeOfPropeller: ETypeOfPropeller, propellerDirectionWithRespectToTheQuay: EPropellerDirectionWithRespectToTheQuay, numberOfPropellers: ENumberOfPropellers) => {
    if (typeOfPropeller == ETypeOfPropeller.MainPropeller) {
        if (propellerDirectionWithRespectToTheQuay == EPropellerDirectionWithRespectToTheQuay.Transversal) {
            return mainPropellerTransverse;
        } else {
            return mainPropellerParallel;
        }
    } else {
        if (numberOfPropellers == ENumberOfPropellers.Single) {
            return singleBowThrusterTransversal;
        } else {
            return doubleBowThrusterTransversal;
        }
    }
};

//it builds a parabola and return distance from vertex
export function getDistanceFromVertex(vertex: any, point: any, y1: any) {
    const [h, k] = vertex;
    const [x1, y1_point] = point;
    const a = (y1_point - k) / Math.pow(x1 - h, 2);
    const b = -2 * a * h;
    const c = a * Math.pow(h, 2) + k;
    const A = a;
    const B = b;
    const C = c - y1;
    const discriminant = Math.pow(B, 2) - 4 * A * C;
    if (discriminant < 0) {
        return null;
    } else {
        const x1_1 = (-B + Math.sqrt(discriminant)) / (2 * A);
        const x1_2 = (-B - Math.sqrt(discriminant)) / (2 * A);
        return Math.abs(x1_1 - x1_2) / 2;
    }
}
